/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { useUrlGenerator } from '@micromag/core/contexts';
import { Link } from '@micromag/core/components';

import ScreenItem from './Screen';

import styles from '../../../styles/items/screen-list.module.scss';

const propTypes = {
    item: MicromagPropTypes.screen.isRequired,
    link: PropTypes.string,
    linkParams: PropTypes.shape({
        story: PropTypes.arrayOf([PropTypes.number, PropTypes.string]).isRequired,
        screen: PropTypes.string,
    }),
    withoutPreview: PropTypes.bool,
    withoutLink: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    link: null,
    linkParams: null,
    withoutPreview: false,
    withoutLink: false,
    className: null,
    children: null,
};

const ScreenListItem = ({
    item,
    link,
    linkParams,
    withoutPreview,
    withoutLink,
    className,
    children,
}) => {
    const url = useUrlGenerator();

    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {!withoutPreview ? (
                <div className={styles.previewContainer}>
                    {item !== null ? <ScreenItem item={item} className={styles.preview} /> : null}
                </div>
            ) : null}
            {!withoutLink ? (
                <Link to={url(link, linkParams)} className={styles.link}>
                    {withoutPreview ? <span className={styles.previewSpace} /> : null}
                    <span className={styles.title}>{children}</span>
                </Link>
            ) : null}
        </div>
    );
};

ScreenListItem.propTypes = propTypes;
ScreenListItem.defaultProps = defaultProps;

export default ScreenListItem;
